import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog'
import { EditPageHeader } from '../../components/EditPageHeader'
import { useTranslation } from '../../locale/useTranslation';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import {DAI_OUTPUTS_AFD_SIGNALING_OPTIONS, DAI_OUTPUTS_AUDIO_TYPE_CONTROL_OPTIONS, DAI_OUTPUTS_BEHAVIORS, DAI_OUTPUTS_CODING_MODE_OPTIONS, DAI_OUTPUTS_FRAMERATE_CONTROL_OPTIONS, DAI_OUTPUTS_GOP_SIZE_UNITS_OPTIONS, DAI_OUTPUTS_INPUT_TYPE_OPTIONS, DAI_OUTPUTS_PCR_CONTROL_OPTIONS, DAI_OUTPUTS_PROFILE_OPTIONS, DAI_OUTPUTS_RATE_CONTROL_MODE_OPTIONS, DAI_OUTPUTS_RAW_FORMAT_OPTIONS, DAI_OUTPUTS_SCAN_TYPE_OPTIONS, DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS, DAI_OUTPUTS_SPECIFICATION_OPTIONS, DAI_OUTPUTS_TIMECODE_INSERTION_OPTIONS, TOAST_TYPES } from '../../framework/constant/constant';
import ToastNotification from '../../components/ToastNotification';

const AddOutputsForm = ({ data, cancelEdit, onSave }) => {

    const lang = useTranslation();

    const blankDataItem = {
        ...data,
        index: data?.index ?? null,
        OutputName: data?.OutputName ?? "",
        VideoDescriptionName: data?.VideoDescriptionName ?? "",
        AudioDescriptionName: data?.AudioDescriptionName ?? "",

        VideoDescriptions: {
            Name: data?.VideoDescriptions?.Name ?? "",
            Height: data?.VideoDescriptions?.Height ?? 0,
            Width: data?.VideoDescriptions?.Width ?? 0,
            CodecSettings: {
                H264Settings: {
                    AfdSignaling: data?.VideoDescriptions?.CodecSettings?.H264Settings?.AfdSignaling ?? "",
                    Bitrate: data?.VideoDescriptions?.CodecSettings?.H264Settings?.Bitrate ?? 0,
                    FramerateControl: data?.VideoDescriptions?.CodecSettings?.H264Settings?.FramerateControl ?? "",
                    GopSize: data?.VideoDescriptions?.CodecSettings?.H264Settings?.GopSize ?? 0,
                    GopSizeUnits: data?.VideoDescriptions?.CodecSettings?.H264Settings?.GopSizeUnits ?? "",
                    RateControlMode: data?.VideoDescriptions?.CodecSettings?.H264Settings?.RateControlMode ?? "",
                    ScanType: data?.VideoDescriptions?.CodecSettings?.H264Settings?.ScanType ?? "",
                    SceneChangeDetect: data?.VideoDescriptions?.CodecSettings?.H264Settings?.SceneChangeDetect ?? "",
                    TimecodeInsertion: data?.VideoDescriptions?.CodecSettings?.H264Settings?.TimecodeInsertion ?? ""
                }
            }
        },

        AudioDescriptions: {
            Name: data?.AudioDescriptions?.Name ?? "",
            AudioTypeControl: data?.AudioDescriptions?.AudioTypeControl ?? "",
            CodecSettings: {
                AacSettings: {
                    Bitrate: data?.AudioDescriptions?.CodecSettings?.AacSettings?.Bitrate ?? 0,
                    CodingMode: data?.AudioDescriptions?.CodecSettings?.AacSettings?.CodingMode ?? "",
                    InputType: data?.AudioDescriptions?.CodecSettings?.AacSettings?.InputType ?? "",
                    Profile: data?.AudioDescriptions?.CodecSettings?.AacSettings?.Profile ?? "",
                    RateControlMode: data?.AudioDescriptions?.CodecSettings?.AacSettings?.RateControlMode ?? "",
                    RawFormat: data?.AudioDescriptions?.CodecSettings?.AacSettings?.RawFormat ?? "",
                    SampleRate: data?.AudioDescriptions?.CodecSettings?.AacSettings?.SampleRate ?? 0,
                    Specification: data?.AudioDescriptions?.CodecSettings?.AacSettings?.Specification ?? ""
                }
            }
        },

        StandardHlsSettings: {
            NameModifier: data?.StandardHlsSettings?.NameModifier ?? "",
            AudioRenditionSets: data?.StandardHlsSettings?.AudioRenditionSets ?? "",
            M3u8Settings: {
                AudioFramesPerPes: data?.StandardHlsSettings?.M3u8Settings?.AudioFramesPerPes ?? 0,
                AudioPids: data?.StandardHlsSettings?.M3u8Settings?.AudioPids ?? "",
                KlvBehavior: data?.StandardHlsSettings?.M3u8Settings?.KlvBehavior ?? "",
                NielsenId3Behavior: data?.StandardHlsSettings?.M3u8Settings?.NielsenId3Behavior ?? "",
                PcrControl: data?.StandardHlsSettings?.M3u8Settings?.PcrControl ?? "",
                PmtPid: data?.StandardHlsSettings?.M3u8Settings?.PmtPid ?? "",
                ProgramNum: data?.StandardHlsSettings?.M3u8Settings?.ProgramNum ?? 0,
                Scte35Behavior: data?.StandardHlsSettings?.M3u8Settings?.Scte35Behavior ?? "",
                Scte35Pid: data?.StandardHlsSettings?.M3u8Settings?.Scte35Pid ?? "",
                TimedMetadataBehavior: data?.StandardHlsSettings?.M3u8Settings?.TimedMetadataBehavior ?? "",
                TimedMetadataPid: data?.StandardHlsSettings?.M3u8Settings?.TimedMetadataPid ?? "",
                VideoPid: data?.StandardHlsSettings?.M3u8Settings?.VideoPid ?? ""
            }
        }
    };

    const [dataItem, setDataItem] = useState(blankDataItem)

    const onChange = (e) => {
        const { name, value } = e.target;
        const keys = name.split('.');
        setDataItem((dataItem) => {
            let updated = { ...dataItem };
            let nested = updated;
            for (let i = 0; i < keys.length - 1; i++) {
                if (!nested[keys[i]]) nested[keys[i]] = {};
                nested = nested[keys[i]];
            }
            nested[keys[keys.length - 1]] = value;
            return updated;
        });
    };

    const isValid = () => {
        if (dataItem.OutputName == undefined || dataItem.OutputName == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_output_name_error_message });
            return false
        }
        return true;
    }
    const handleSubmit = () => {
        if (!isValid()) return;

        const finalData = {
            index: dataItem?.index ?? null,
            OutputName: dataItem.OutputName ?? "",
            VideoDescriptionName: dataItem.VideoDescriptionName ?? "",
            AudioDescriptionName: dataItem.AudioDescriptionName ?? "",
            VideoDescriptions: {
                Name: dataItem.VideoDescriptions?.Name ?? "",
                Height: Number(dataItem.VideoDescriptions?.Height ?? 0),
                Width: Number(dataItem.VideoDescriptions?.Width ?? 0),
                CodecSettings: {
                    H264Settings: {
                        AfdSignaling: dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.AfdSignaling ?? "",
                        Bitrate: Number(dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.Bitrate ?? 0),
                        FramerateControl: dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.FramerateControl ?? "",
                        GopSize: Number(dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.GopSize ?? 0),
                        GopSizeUnits: dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.GopSizeUnits ?? "",
                        RateControlMode: dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.RateControlMode ?? "",
                        ScanType: dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.ScanType ?? "",
                        SceneChangeDetect: dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.SceneChangeDetect ?? "",
                        TimecodeInsertion: dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.TimecodeInsertion ?? "",
                    }
                }
            },
            AudioDescriptions: {
                Name: dataItem.AudioDescriptions?.Name ?? "",
                AudioTypeControl: dataItem.AudioDescriptions?.AudioTypeControl ?? "",
                CodecSettings: {
                    AacSettings: {
                        Bitrate: Number(dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.Bitrate ?? 0),
                        CodingMode: dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.CodingMode ?? "",
                        InputType: dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.InputType ?? "",
                        Profile: dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.Profile ?? "",
                        RateControlMode: dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.RateControlMode ?? "",
                        RawFormat: dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.RawFormat ?? "",
                        SampleRate: Number(dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.SampleRate ?? 0),
                        Specification: dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.Specification ?? "",
                    }
                }
            },
            StandardHlsSettings: {
                NameModifier: dataItem.StandardHlsSettings?.NameModifier ?? "",
                AudioRenditionSets: dataItem.StandardHlsSettings?.AudioRenditionSets ?? "",
                M3u8Settings: {
                    AudioFramesPerPes: Number(dataItem.StandardHlsSettings?.M3u8Settings?.AudioFramesPerPes ?? 0),
                    AudioPids: dataItem.StandardHlsSettings?.M3u8Settings?.AudioPids ?? "",
                    KlvBehavior: dataItem.StandardHlsSettings?.M3u8Settings?.KlvBehavior ?? "",
                    NielsenId3Behavior: dataItem.StandardHlsSettings?.M3u8Settings?.NielsenId3Behavior ?? "",
                    PcrControl: dataItem.StandardHlsSettings?.M3u8Settings?.PcrControl ?? "",
                    PmtPid: dataItem.StandardHlsSettings?.M3u8Settings?.PmtPid ?? "",
                    ProgramNum: Number(dataItem.StandardHlsSettings?.M3u8Settings?.ProgramNum ?? 0),
                    Scte35Behavior: dataItem.StandardHlsSettings?.M3u8Settings?.Scte35Behavior ?? "",
                    Scte35Pid: dataItem.StandardHlsSettings?.M3u8Settings?.Scte35Pid ?? "",
                    TimedMetadataBehavior: dataItem.StandardHlsSettings?.M3u8Settings?.TimedMetadataBehavior ?? "",
                    TimedMetadataPid: dataItem.StandardHlsSettings?.M3u8Settings?.TimedMetadataPid ?? "",
                    VideoPid: dataItem.StandardHlsSettings?.M3u8Settings?.VideoPid ?? "",
                }
            }
        };
        onSave(finalData);
        cancelEdit();
    };


    return (
        <BossDialog title={dataItem?.Title ?? lang.dai_add_output_dialog_header} onClose={cancelEdit} width="70vw">
            <EditPageHeader title={dataItem?.OutputName || lang.dai_add_output_dialog_header} onSubmit={handleSubmit} onCancel={cancelEdit} />
            <div className="border rounded p-3 mt-2">
                <div className="row">
                    <div className="col-4 mb-2">
                        <label>{lang.output_name_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="OutputName"
                            placeholder="Output Name"
                            value={dataItem.OutputName || ''}
                            onChange={onChange}
                            required
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.name_modifier_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="StandardHlsSettings.NameModifier"
                            placeholder="Name Modifier"
                            value={dataItem.StandardHlsSettings?.NameModifier || ''}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.audio_rendition_sets_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="StandardHlsSettings.AudioRenditionSets"
                            placeholder="Audio Rendition Sets"
                            value={dataItem.StandardHlsSettings?.AudioRenditionSets || ''}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4 mb-2">
                        <label>{lang.audio_frames_per_pes_label}</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            name="StandardHlsSettings.M3u8Settings.AudioFramesPerPes"
                            placeholder="Audio Frames Per PES"
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.AudioFramesPerPes || ''}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.audio_pids_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="StandardHlsSettings.M3u8Settings.AudioPids"
                            placeholder="Audio PIDs"
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.AudioPids || ''}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.klv_behavior_label}</label>
                        <DropDownList
                            className="form-control form-control-sm"
                            style={{ backgroundColor: "white" }}
                            data={Object.values(DAI_OUTPUTS_BEHAVIORS)}
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.KlvBehavior || ''}
                            onChange={onChange}
                            name="StandardHlsSettings.M3u8Settings.KlvBehavior"
                        />
                    </div>
                    <div className="col-4 mb-2">
                        <label>{lang.nielsen_id3_behavior_label}</label>
                        <DropDownList
                            className="form-control form-control-sm"
                            style={{ backgroundColor: "white" }}
                            data={Object.values(DAI_OUTPUTS_BEHAVIORS)}
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.NielsenId3Behavior || ''}
                            onChange={onChange}
                            name="StandardHlsSettings.M3u8Settings.NielsenId3Behavior"
                            placeholder="Nielsen ID3 Behavior"
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.pcr_control_label}</label>
                        <DropDownList
                            className="form-control form-control-sm"
                            style={{ backgroundColor: "white" }}
                            data={Object.values(DAI_OUTPUTS_PCR_CONTROL_OPTIONS)}
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.PcrControl || ''}
                            onChange={onChange}
                            name="StandardHlsSettings.M3u8Settings.PcrControl"
                            placeholder="PCR Control"
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.pmt_pid_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="StandardHlsSettings.M3u8Settings.PmtPid"
                            placeholder="PMT PID"
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.PmtPid || ''}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4 mb-2">
                        <label>{lang.program_num_label}</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            name="StandardHlsSettings.M3u8Settings.ProgramNum"
                            placeholder="Program Num"
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.ProgramNum || ''}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.scte35_behavior_label}</label>
                        <DropDownList
                            className="form-control form-control-sm"
                            style={{ backgroundColor: "white" }}
                            data={Object.values(DAI_OUTPUTS_BEHAVIORS)}
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.Scte35Behavior || ''}
                            onChange={onChange}
                            name="StandardHlsSettings.M3u8Settings.Scte35Behavior"
                            placeholder="SCTE35 Behavior"
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.scte35_pid_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="StandardHlsSettings.M3u8Settings.Scte35Pid"
                            placeholder="SCTE35 PID"
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.Scte35Pid || ''}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4 mb-2">
                        <label>{lang.timed_metadata_behavior_label}</label>
                        <DropDownList
                            className="form-control form-control-sm"
                            style={{ backgroundColor: "white" }}
                            data={Object.values(DAI_OUTPUTS_BEHAVIORS)}
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.TimedMetadataBehavior || ''}
                            onChange={onChange}
                            name="StandardHlsSettings.M3u8Settings.TimedMetadataBehavior"
                            placeholder="Timed Metadata Behavior"
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.timed_metadata_pid_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="StandardHlsSettings.M3u8Settings.TimedMetadataPid"
                            placeholder="Timed Metadata PID"
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.TimedMetadataPid || ''}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4">
                        <label>{lang.video_pid_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="StandardHlsSettings.M3u8Settings.VideoPid"
                            placeholder="Video PID"
                            value={dataItem.StandardHlsSettings?.M3u8Settings?.VideoPid || ''}
                            onChange={onChange}
                        />
                    </div>
                </div>
            </div>
            <div className="row mt-2 p-2 g-3">
                <div className=" border col-md-6">
                    <h5>{lang.video_descriptions_title }</h5>
                    <div className="border shadow rounded p-3 mb-2" >
                        <div className="row">
                            <div className="col-6">
                                <label className="form-label">{lang.name_label}</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="VideoDescriptions.Name"
                                    value={dataItem.VideoDescriptions?.Name || ''}
                                    onChange={onChange}
                                    placeholder={lang.name_label}
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label">{lang.height_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="VideoDescriptions.Height"
                                    value={dataItem.VideoDescriptions?.Height || ''}
                                    onChange={onChange}
                                    placeholder={lang.height_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.width_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="VideoDescriptions.Width"
                                    value={dataItem.VideoDescriptions?.Width || ''}
                                    onChange={onChange}
                                    placeholder={lang.width_label}
                                />
                            </div>
                        </div>
                        <h6 className="mt-4">{lang.h264_settings_title }</h6>
                        <div className="row">
                            <div className="col-6">
                                <label className="form-label">{lang.afd_signaling_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_AFD_SIGNALING_OPTIONS)}
                                    value={dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.AfdSignaling || ''}
                                    onChange={onChange}
                                    name="VideoDescriptions.CodecSettings.H264Settings.AfdSignaling"
                                    placeholder={lang.afd_signaling_label}
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label">{lang.bitrate_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="VideoDescriptions.CodecSettings.H264Settings.Bitrate"
                                    value={dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.Bitrate || ''}
                                    onChange={onChange}
                                    placeholder={lang.bitrate_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.framerate_control_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_FRAMERATE_CONTROL_OPTIONS)}
                                    value={dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.FramerateControl || ''}
                                    onChange={onChange}
                                    name="VideoDescriptions.CodecSettings.H264Settings.FramerateControl"
                                    placeholder={lang.framerate_control_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.gop_size_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="VideoDescriptions.CodecSettings.H264Settings.GopSize"
                                    value={dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.GopSize || ''}
                                    onChange={onChange}
                                    placeholder={lang.gop_size_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.gop_size_units_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_GOP_SIZE_UNITS_OPTIONS)}
                                    value={dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.GopSizeUnits || ''}
                                    onChange={onChange}
                                    name="VideoDescriptions.CodecSettings.H264Settings.GopSizeUnits"
                                    placeholder={lang.gop_size_units_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.rate_control_mode_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_RATE_CONTROL_MODE_OPTIONS)}
                                    value={dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.RateControlMode || ''}
                                    onChange={onChange}
                                    name="VideoDescriptions.CodecSettings.H264Settings.RateControlMode"
                                    placeholder={lang.rate_control_mode_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.scan_type_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_SCAN_TYPE_OPTIONS)}
                                    value={dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.ScanType || ''}
                                    onChange={onChange}
                                    name="VideoDescriptions.CodecSettings.H264Settings.ScanType"
                                    placeholder={lang.scan_type_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.scene_change_detect_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS)}
                                    value={dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.SceneChangeDetect || ''}
                                    onChange={onChange}
                                    name="VideoDescriptions.CodecSettings.H264Settings.SceneChangeDetect"
                                    placeholder={lang.scene_change_detect_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.timecode_insertion_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_TIMECODE_INSERTION_OPTIONS)}
                                    value={dataItem.VideoDescriptions?.CodecSettings?.H264Settings?.TimecodeInsertion || ''}
                                    onChange={onChange}
                                    name="VideoDescriptions.CodecSettings.H264Settings.TimecodeInsertion"
                                    placeholder={lang.timecode_insertion_label}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="border col-md-6">
                    <h5>{lang.audio_descriptions_title}</h5>
                    <div className="border shadow rounded p-3 mb-2"  style={{height: "70vh"}}>
                        <div className="row">
                            <div className="col-6">
                                <label className="form-label">{lang.audio_name_label}</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="AudioDescriptions.Name"
                                    value={dataItem.AudioDescriptions?.Name || ''}
                                    onChange={onChange}
                                    placeholder={lang.audio_name_label}
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label">{lang.audio_type_control_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_AUDIO_TYPE_CONTROL_OPTIONS)}
                                    value={dataItem.AudioDescriptions?.AudioTypeControl || ''}
                                    onChange={onChange}
                                    name="AudioDescriptions.AudioTypeControl"
                                    placeholder={lang.audio_type_control_label}
                                />
                            </div>
                            <h6 className="mt-3 col-12">{lang.aac_settings_title}</h6>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.bitrate_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="AudioDescriptions.CodecSettings.AacSettings.Bitrate"
                                    value={dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.Bitrate || ''}
                                    onChange={onChange}
                                    placeholder={lang.bitrate_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.coding_mode_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_CODING_MODE_OPTIONS)}
                                    value={dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.CodingMode || ''}
                                    onChange={onChange}
                                    name="AudioDescriptions.CodecSettings.AacSettings.CodingMode"
                                    placeholder={lang.coding_mode_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.input_type_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_INPUT_TYPE_OPTIONS)}
                                    value={dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.InputType || ''}
                                    onChange={onChange}
                                    name="AudioDescriptions.CodecSettings.AacSettings.InputType"
                                    placeholder={lang.input_type_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.profile_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_PROFILE_OPTIONS)}
                                    value={dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.Profile || ''}
                                    onChange={onChange}
                                    name="AudioDescriptions.CodecSettings.AacSettings.Profile"
                                    placeholder={lang.profile_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.rate_control_mode_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_RATE_CONTROL_MODE_OPTIONS)}
                                    value={dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.RateControlMode || ''}
                                    onChange={onChange}
                                    name="AudioDescriptions.CodecSettings.AacSettings.RateControlMode"
                                    placeholder={lang.rate_control_mode_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.raw_format_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_RAW_FORMAT_OPTIONS)}
                                    value={dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.RawFormat || ''}
                                    onChange={onChange}
                                    name="AudioDescriptions.CodecSettings.AacSettings.RawFormat"
                                    placeholder={lang.raw_format_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.sample_rate_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="AudioDescriptions.CodecSettings.AacSettings.SampleRate"
                                    value={dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.SampleRate || ''}
                                    onChange={onChange}
                                    placeholder={lang.sample_rate_label}
                                />
                            </div>
                            <div className="col-6 mt-2">
                                <label className="form-label">{lang.specification_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ backgroundColor: 'white' }}
                                    data={Object.values(DAI_OUTPUTS_SPECIFICATION_OPTIONS)}
                                    value={dataItem.AudioDescriptions?.CodecSettings?.AacSettings?.Specification || ''}
                                    onChange={onChange}
                                    name="AudioDescriptions.CodecSettings.AacSettings.Specification"
                                    placeholder={lang.specification_label}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BossDialog>
    );
};


export default AddOutputsForm